import React, { useEffect, useState } from "react";
import Navbar from "../components/layout/navbar";
import Banner from "../components/pages/Home/banner";
import Revolution from "../components/pages/Home/revolution";
import Features from "../components/pages/Home/features";
import Works from "../components/pages/Home/works";
import Pricing from "../components/pages/Home/pricing";
import Blogs from "../components/pages/Home/blogs";
import Faqs from "../components/pages/Aboutus/faqs";
import Footer from "../components/layout/footer";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import IntroVideo from "../components/pages/Home/introVideo";
import Contact from "../components/pages/Home/contact";

const Home = () => {
  const navigate = useNavigate();
  const [showIntro, setShowIntro] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const loginData = secureLocalStorage.getItem("loginCredentials");

    if (loginData) {
      navigate("/dashboard");
    }

    const introDisplayed = sessionStorage.getItem("introDisplayed");

    if (!introDisplayed) {
      setShowIntro(true);
      sessionStorage.setItem("introDisplayed", "true");
    }

    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setShowIntro(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [navigate]);

  return (
    <>
      <Navbar />
      {/* {showIntro && <IntroVideo />} */}
      <Banner />
      <Revolution />
      <Works />
      <Features />
      <Pricing />
      <Blogs />
      <Faqs />
      {/* <Contact /> */}
      <Footer />
    </>
  );
};

export default Home;
